// Formato universal de dinero - Sprint 45.
// . miles, , decimales, 2 decimales fijos para todas las monedas.

const _FMT = new Intl.NumberFormat('es-CO', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Formatea con separador miles "." y decimales ",".
 * Siempre 2 decimales. Ej: fmtMoney(100000, 'COP') -> "COP 100.000,00".
 */
export function fmtMoney(value, moneda) {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (Number.isNaN(n)) return '—';
  const m = (moneda || '').toString().trim();
  return (m ? m + ' ' : '') + _FMT.format(n);
}

/**
 * Formatea sin prefijo de moneda. Para inputs, campos, valores aislados.
 */
export function fmtNumber(value) {
  if (value === null || value === undefined || value === '') return '';
  const n = Number(value);
  if (Number.isNaN(n)) return '';
  return _FMT.format(n);
}

/**
 * Parser inverso: "100.000,00" -> 100000. Tolerante: acepta tambien "100000".
 */
export function parseMoney(text) {
  if (text === null || text === undefined) return 0;
  const s = String(text).trim();
  if (!s) return 0;
  // Quitar todo excepto digitos, coma, menos.
  const cleaned = s.replace(/[^\d,-]/g, '').replace(',', '.');
  const n = Number(cleaned);
  return Number.isNaN(n) ? 0 : n;
}
